import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import CarrierNestingReport from '../../components/CarrierNestingReport';
import {
  getPercentageColumns,
  getNumberColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/CarrierNestingOperatorSelectors';
import CarrierNestingOperatorReportMode from './CarrierNestingOperatorReportMode';

const MODE_TABS = [
  { value: CarrierNestingOperatorReportMode.percentage, label: '%' },
  { value: CarrierNestingOperatorReportMode.number, label: '#' },
];

export class CarrierNestingOperatorContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportMode: CarrierNestingOperatorReportMode.percentage,
    };
  }

  changeMode = reportMode => this.setState({ reportMode });

  renderPercentage() {
    return (
      <CarrierNestingReport
        reportId={ReportDefinitions.CARDIT_NESTING_OPERATOR_801.id}
        columns={this.props.percentageColumns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        modeTabs={MODE_TABS}
        changeMode={this.changeMode}
        mode={CarrierNestingOperatorReportMode.percentage}
      />
    );
  }

  renderNumber() {
    return (
      <CarrierNestingReport
        reportId={ReportDefinitions.CARDIT_NESTING_OPERATOR_801.id}
        columns={this.props.numberColumns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        modeTabs={MODE_TABS}
        changeMode={this.changeMode}
        mode={CarrierNestingOperatorReportMode.number}
      />
    );
  }

  render() {
    switch (this.state.reportMode) {
      case CarrierNestingOperatorReportMode.percentage:
        return this.renderPercentage();
      case CarrierNestingOperatorReportMode.number:
        return this.renderNumber();
      default:
        return (<div id="report-mode-error">Report mode &quot;{this.state.reportMode}&quot; is not implemented</div>);
    }
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    percentageColumns: getPercentageColumns(state),
    numberColumns: getNumberColumns(state),
  };
}

CarrierNestingOperatorContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  percentageColumns: PropTypes.arrayOf(PropTypes.object),
  numberColumns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(CarrierNestingOperatorContainer);
